// @flow
import { connect } from 'react-redux';
import { setCurrentVoucherDetails } from '../../../../modules/Voucher';
import SelectedVoucherItem from './SelectedVoucherItem';

const mapStateToProps = (state, ownProps) => ({
  selectedVoucher: ownProps.selectedVoucher,
});

const mapDispatchToProps = (dispatch: Function) => ({
  setCurrentVoucherDetails: (object: Object) => dispatch(setCurrentVoucherDetails(object)),
});

export default connect(mapStateToProps, mapDispatchToProps)(SelectedVoucherItem);
